module.exports = __webpack_public_path__ + "img/Artboard.ae206165.png";